// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.result_plc[data-v-cd6b2aca] {cursor: pointer; color: #000;}\n", ""]);
// Exports
module.exports = exports;
